/**
 * @generated SignedSource<<e007d3cab575176e77856e3260c0742d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplaceLayoutSecondaryRefetchContainer_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceContainerSecondary_viewer" | "PdpRespMarketplaceLayoutSecondaryContextProvider_viewer">;
  readonly " $fragmentType": "PdpRespMarketplaceLayoutSecondaryRefetchContainer_viewer";
};
export type PdpRespMarketplaceLayoutSecondaryRefetchContainer_viewer$key = {
  readonly " $data"?: PdpRespMarketplaceLayoutSecondaryRefetchContainer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceLayoutSecondaryRefetchContainer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "guestId"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "itemIds"
    },
    {
      "kind": "RootArgument",
      "name": "personalizationId"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./PdpRespMarketplaceLayoutSecondaryRefetchContainerQuery.graphql')
    }
  },
  "name": "PdpRespMarketplaceLayoutSecondaryRefetchContainer_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespMarketplaceContainerSecondary_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespMarketplaceLayoutSecondaryContextProvider_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0d61bbb66241483a3ea188ec15b3bd24";

export default node;
